/*
 * DER STANDARD-ORDNER DER DATEIVORSCHAU — pro Mensch und Arbeitsbereich.
 *
 * Sahori, 11.09.2026: "'Als Standard' does not seem to be long-term pinning the
 * folders I wanna see when I open sessions again."
 *
 * Bis dahin lebte der gemerkte Ordner NUR in der Tab-Konfiguration genau EINES
 * File-Preview-Reiters (config.watchPath). Jeder neu geoeffnete Reiter (Plus-Menue,
 * Layout-Builder, Tool Hub, zweiter Bildschirm mit eigenem Layout-Schluessel) startete
 * wieder im Arbeitsverzeichnis — der Knopf wirkte also nur, solange genau dieser eine
 * Reiter ueberlebte. Gemessen am 12.10.2026: in Sahoris engelmann-developer-Layout
 * stand watchPath wieder auf dem Arbeitsverzeichnis.
 *
 * Jetzt merkt sich der Knopf den Ordner zusaetzlich hier, und jeder Reiter, der
 * nur das Arbeitsverzeichnis als Start kennt, beginnt im gemerkten Ordner. Ein
 * Reiter mit einem bewusst anderen Start (Buehnen-Rezept, frueher gemerkter
 * Ordner) behaelt seinen.
 */

const PRAEFIX = 'cui-filepreview-standard';

export function standardOrdnerSchluessel(userId: string | null | undefined, arbeitsbereich: string): string {
  return `${PRAEFIX}:${userId || 'lokal'}:${arbeitsbereich}`;
}

export function liesStandardOrdner(userId: string | null | undefined, arbeitsbereich: string | null | undefined): string | null {
  if (!arbeitsbereich) return null;
  try {
    const wert = localStorage.getItem(standardOrdnerSchluessel(userId, arbeitsbereich));
    return wert && wert.trim() ? wert : null;
  } catch {
    return null; // silent-ok: localStorage gesperrt -> es gilt der Start aus der Tab-Konfiguration
  }
}

export function merkeStandardOrdner(userId: string | null | undefined, arbeitsbereich: string | null | undefined, ordner: string): boolean {
  if (!arbeitsbereich || !ordner) return false;
  try {
    localStorage.setItem(standardOrdnerSchluessel(userId, arbeitsbereich), ordner);
    return true;
  } catch (err) {
    console.warn('[dateiStandardOrdner] Standard-Ordner liess sich nicht merken:', err);
    return false;
  }
}

/**
 * Start-Ordner eines File-Preview-Reiters.
 *
 * Ein `konfigPfad`, der vom Arbeitsverzeichnis abweicht, ist bewusst gesetzt
 * (gemerkt oder vom Rezept vorgegeben) und gewinnt. Steht dort nur der
 * Grundwert (oder nichts), gilt der gemerkte Standard des Menschen.
 */
export function startOrdner(opts: {
  konfigPfad?: string | null;
  grundwerte: Array<string | null | undefined>;
  gemerkt?: string | null;
}): string {
  const grund = opts.grundwerte.filter((g): g is string => !!g);
  const konfig = opts.konfigPfad || '';
  if (konfig && !grund.includes(konfig)) return konfig;
  return opts.gemerkt || konfig || grund[0] || '';
}

/** Elternordner; die Wurzel bleibt die Wurzel. */
export function elternOrdner(pfad: string): string {
  return pfad.replace(/\/[^/]+\/?$/, '') || '/';
}
